import { Text } from "@ucl/react-library";
import { TFunction } from "i18next";

export const translationMapping = (t: TFunction) => {
  return {
    br: <br />,
    faqLink: (
      <a href={t("links.faqLink")} target="_blank" rel="noopener noreferrer" className="!text-primary !underline" >{ }</a>
    ),
    contactLink: (
      <a href={t("links.contactLink")} target="_blank" rel="noopener noreferrer" className="!text-primary !underline">{ }</a>
    ),
    tandcsLink: (
      <a href={t("links.tandcsLink")} target="_blank" rel="noopener noreferrer" className="!text-primary !underline" >{ }</a>
    ),
    privacyPolicyLink: (
      <a
        href={t("links.privacyPolicyLink")}
        target="_blank"
        rel="noopener noreferrer"
        className="!text-primary !underline"
      >{ }</a>
    ),
    strong: <Text.P size="large" fontWeight="semi-bold" className="inline " />,
    smallStrong: <Text.P fontWeight="semi-bold" className="inline " />,
  };
};
